"use client";

import { Translate } from "@/components/Translate";

import type { ComponentProps, ReactNode } from "react";
import styles from "./cart.module.css";
import { useCart } from "./hooks";
import { ScrollAreaRoot, ScrollAreaBar, ScrollAreaViewport } from "@/components/ui/ScrollArea";
import { clsx } from "@frend-digital/ui";

export const CartContent = ({
	className,
	children,
	itemTitleClass: itemTitle,
}: {
	className?: string;
	itemTitleClass?: string;
	children?: ReactNode;
}) => {
	const { data } = useCart();
	const totalItemCount =
		data?.items?.reduce((total, item) => total + (item?.quantity ?? 0), 0) || 0;

	return (
		<>
			<div className={clsx(styles.cartItemHeader, itemTitle)}>
				<p className={styles.amount} aria-live="polite" aria-atomic>
					{totalItemCount}{" "}
					{totalItemCount === 1 ? <Translate>item</Translate> : <Translate>items</Translate>}
				</p>
			</div>

			{children}
		</>
	);
};
